import { EventBlock } from "@iventis/domain-model/model/eventBlock";
import { ScheduleConfigEventBlockType } from "@iventis/domain-model/model/scheduleConfigEventBlockType";
import { IventisTableData, TimeCellEditorParams, AdditionalTimeCellEditorParams, IventisColDef } from "@iventis/data-table";

export type TimeRule = Pick<EventBlock, "relativeEventRules" | "recurringEventRules">;

export enum TimeType {
    Relative,
    Fixed,
}

export type AdditionalTimeRuleCellEditorParams = {
    eventBlockTypes: ScheduleConfigEventBlockType[];
    scheduleDaysMap: Map<number, Date>;
};

export interface TimeRuleParams extends IventisColDef {
    cellEditorParams: AdditionalTimeRuleCellEditorParams & AdditionalTimeCellEditorParams;
}

export type TimeRulesCellEditorParams<T extends IventisTableData = IventisTableData> = TimeCellEditorParams<T> & AdditionalTimeRuleCellEditorParams;
